export const ROLES_ACTIONS = {
    GET: 'ROLES_GET',
    FIND: 'ROLES_FIND',
    ERROR: 'ROLES_ERROR',
    SUCCESS: 'ROLES_SUCCESS',
    CLEAN: 'ROLES_CLEAN',

    GET_TASKS: 'ROLES_GET_TASKS',

    SUGGESTION: 'ROLES_SUGGESTION',
    SUGGESTION_CLEAN: 'ROLES_SUGGESTION_CLEAN',
}